import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Pagination } from '@core/entities';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find(query: string): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/getFaqbytitle/${query}`);
  }

  getAll(categoryId: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/getFaqbyCategory/${categoryId}/1/`);
  }

  get(id: number): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/getFaqbyId/${id}`).pipe(map((res) => res.result[0]));
  }

  create(formData: FormData): Observable<any> {
    return this._http.post<any>(`${this._apiUrl}/createFaq`, formData);
  }

  update(id: number, formData: FormData): Observable<any> {
    return this._http.put<any>(`${this._apiUrl}/updateFaq/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._apiUrl}/deleteFaq/${id}`);
  }

  downloadDocument(data: { name: string; faq_id: number; type: number }): Observable<Blob> {
    return this._http.post(`${this._apiUrl}/download-faqs-document`, data, {
      responseType: 'blob' as 'json',
    }) as Observable<Blob>;
  }

  getContentFaqs(pagination: Partial<Pagination>, queryParams?: FilterQuery): Observable<any> {
    return this._http.get<any>(`${this._apiUrl}/getOwnerFaqs/${pagination.page}/${pagination.pageSize}`, { params: queryParams });
  }
}
